import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs } from "../../../../adapter-vue";
import TUIChatEngine, {
  TUITranslateService,
  IMessageModel,
} from "@tencentcloud/chat-uikit-engine";
import Icon from "../../../common/Icon.vue";
import ReadStatus from "./read-status/index.vue";
import MessageQuote from "./message-quote/index.vue";
import Avatar from "../../../common/Avatar/index.vue";
import MessageTranslate from "./message-translate/index.vue";
import MessageConvert from "./message-convert/index.vue";
import RadioSelect from "../../../common/RadioSelect/index.vue";
import loadingIcon from "../../../../assets/icon/loading.png";
import { shallowCopyMessage } from "../../utils/utils";
import { isPC } from "../../../../utils/env";

interface IProps {
  messageItem: IMessageModel;
  content?: any;
  classNameList?: string[];
  blinkMessageIDList?: string[];
  isMultipleSelectMode?: boolean;
  isAudioPlayed?: boolean | undefined;
  multipleSelectedMessageIDList?: string[];
}

interface IEmits {
  (e: "resendMessage"): void;
  (e: "blinkMessage", messageID: string): void;
  (
    e: "setReadReceiptPanelVisible",
    visible: boolean,
    message?: IMessageModel
  ): void;
  (
    e: "changeSelectMessageIDList",
    options: { type: "add" | "remove" | "clearAll"; messageID: string }
  ): void;
  // Only for uniapp
  (e: "scrollTo", scrollHeight: number): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-bubble',
  props: {
    messageItem: { default: () => ({} as IMessageModel) },
    content: { default: () => ({}) },
    classNameList: { default: () => [] },
    blinkMessageIDList: { default: () => [] },
    isMultipleSelectMode: { type: Boolean, default: false },
    isAudioPlayed: { type: [Boolean, null], default: false },
    multipleSelectedMessageIDList: { default: () => [] }
  },
  emits: ["resendMessage", "blinkMessage", "setReadReceiptPanelVisible", "changeSelectMessageIDList", "scrollTo"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "resendMessage"): void;
  (e: "blinkMessage", messageID: string): void;
  (
    e: "setReadReceiptPanelVisible",
    visible: boolean,
    message?: IMessageModel
  ): void;
  (
    e: "changeSelectMessageIDList",
    options: { type: "add" | "remove" | "clearAll"; messageID: string }
  ): void;
  // Only for uniapp
  (e: "scrollTo", scrollHeight: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { messageItem: IMessageModel, content: any, classNameList: string[], blinkMessageIDList: string[], isMultipleSelectMode: boolean, isAudioPlayed: boolean | undefined, multipleSelectedMessageIDList: string[] }





const TYPES = TUIChatEngine.TYPES;
const riskImageReplaceUrl =
  "https://web.sdk.qcloud.com/component/TUIKit/assets/has_risk_default.png";
const needLoadingIconMessageType = [
  TYPES.MSG_LOCATION,
  TYPES.MSG_TEXT,
  TYPES.MSG_CUSTOM,
  TYPES.MSG_MERGER,
  TYPES.MSG_FACE,
];

const { blinkMessageIDList, messageItem: message } = toRefs(props);

const isMultipleSelected = computed<boolean>(() => {
  return props.multipleSelectedMessageIDList.includes(message.value.ID);
});

const isDisplayUnplayMark = computed<boolean>(() => {
  return (
    message.value.flow === "in" &&
    message.value.status === "success" &&
    message.value.type === TYPES.MSG_AUDIO &&
    !props.isAudioPlayed
  );
});

const containerClassNameList = computed(() => {
  return [
    "message-bubble",
    isMultipleSelected.value ? "multiple-selected" : "",
    ...props.classNameList,
  ];
});

// When an emoji is deleted, the `reactionList` will update the corresponding emoji's `totalUserCount`.
const hasEmojiReaction = computed(() => {
  return message.value?.reactionList.some(
    (item: any) => item.totalUserCount !== 0
  );
});

const isNoPadding = computed(() => {
  return (
    !hasEmojiReaction.value &&
    [TYPES.MSG_IMAGE, TYPES.MSG_VIDEO, TYPES.MSG_MERGER].includes(
      message.value.type
    )
  );
});

const riskContentText = computed<string>(() => {
  let content = TUITranslateService.t("TUIChat.涉及敏感内容") + ", ";
  if (message.value.flow === "out") {
    content += TUITranslateService.t("TUIChat.发送失败");
  } else {
    content += TUITranslateService.t(
      message.value.type === TYPES.MSG_AUDIO
        ? "TUIChat.无法收听"
        : "TUIChat.无法查看"
    );
  }
  return content;
});

const isBlink = computed(() => {
  if (message.value?.ID) {
    return blinkMessageIDList?.value?.includes(message.value.ID);
  }
  return false;
});

function toggleMultipleSelect(isSelected: boolean) {
  emits("changeSelectMessageIDList", {
    type: isSelected ? "add" : "remove",
    messageID: message.value.ID,
  });
}

function resendMessage() {
  if (!message.value?.hasRiskContent) {
    emits("resendMessage");
  }
}

function blinkMessage(messageID: string) {
  emits("blinkMessage", messageID);
}

function scrollTo(scrollHeight: number) {
  emits("scrollTo", scrollHeight);
}

function openReadUserPanel() {
  emits("setReadReceiptPanelVisible", true, message.value);
}

return { __sfc: true,emits, props, TYPES, riskImageReplaceUrl, needLoadingIconMessageType, blinkMessageIDList, message, isMultipleSelected, isDisplayUnplayMark, containerClassNameList, hasEmojiReaction, isNoPadding, riskContentText, isBlink, toggleMultipleSelect, resendMessage, blinkMessage, scrollTo, openReadUserPanel, Icon, ReadStatus, MessageQuote, Avatar, MessageTranslate, MessageConvert, RadioSelect, loadingIcon, shallowCopyMessage, isPC }
}

})